import { render, staticRenderFns } from "./CSelectSnsList.vue?vue&type=template&id=0e510cda&"
import script from "./CSelectSnsList.vue?vue&type=script&lang=ts&"
export * from "./CSelectSnsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports